export { default } from "./useAdvisoryMessageGet";
